type WidgetBrandingPlan = {
  removeRevokonekBranding?: boolean;
  removeRevocomBranding?: boolean;
};

type WidgetBrandingInput = {
  showPoweredBy?: boolean;
  organization?: {
    plan?: WidgetBrandingPlan;
  };
};

/** Branding stays visible unless the current plan explicitly removes it. */
export function shouldShowWidgetBranding(
  input?: WidgetBrandingInput | null,
): boolean {
  const plan = input?.organization?.plan;
  if (plan?.removeRevokonekBranding || plan?.removeRevocomBranding) {
    return false;
  }
  return input?.showPoweredBy !== false;
}
